"use client";

import { useState, useEffect } from "react";
import usersData from "./userData";
import Pagination from "../../components/Pagination";

export default function UserManagement({
  initialUsers = [],
  totalUsers = 738,
  onAddUser = () => {},
  onSearch = () => {},
  onToggleStatus = () => {},
}) {
  const [state, setState] = useState({
    idFilter: "",
    emailFilter: "",
    emailFilter2: "",
    allUsers: initialUsers.length > 0 ? initialUsers : usersData,
    currentPage: 1,
    displayedUsers: [],
  });

  const itemsPerPage = 12;

  useEffect(() => {
    const startIndex = (state.currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setState((prevState) => ({
      ...prevState,
      displayedUsers: prevState.allUsers.slice(
        startIndex,
        Math.min(prevState.allUsers.length, endIndex)
      ),
    }));
  }, [state.currentPage, state.allUsers]);

  const handleSearch = () => {};
  const handleReset = () => {
    setState((prevState) => ({
      ...prevState,
      idFilter: "",
      emailFilter: "",
      emailFilter2: "",
    }));
  };

  const handleToggleStatus = (userId, index) => {
    const newUsers = [...state.allUsers];
    newUsers[index].active = !newUsers[index].active;
    setState((prevState) => ({ ...prevState, allUsers: newUsers }));
    onToggleStatus(userId, newUsers[index].active);
  };

  return (
    <div className="ml-72 bg-gray-50 min-h-screen p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="font-poppins font-medium text-3xl leading-none text-[#173363]">
          User Management
        </h1>
        <button
          onClick={onAddUser}
          className="bg-[#173363] hover:bg-blue-900 text-white px-4 py-3 rounded-md  flex items-center font-semibold text-xl leading-none"
        >
          <span className="mr-1 font-semibold text-xl leading-none">+</span> Add
          Users
        </button>
      </div>

      {/* Search Section */}
      <div className="bg-white rounded-lg p-6 mb-6">
        <div className="flex items-center gap-4">
          <input
            type="text"
            placeholder="Search by Id"
            value={state.idFilter}
            onChange={(e) => setState({ ...state, idFilter: e.target.value })}
            className="border border-gray-300 rounded-md px-3 py-3 flex-1"
          />
          <input
            type="text"
            placeholder="Search by Email"
            value={state.emailFilter}
            onChange={(e) =>
              setState({ ...state, emailFilter: e.target.value })
            }
            className="border border-gray-300 rounded-md px-3 py-3 flex-1"
          />
          <input
            type="text"
            placeholder="Search by Email"
            value={state.emailFilter2}
            onChange={(e) =>
              setState({ ...state, emailFilter2: e.target.value })
            }
            className="border border-gray-300 rounded-md px-3 py-3 flex-1"
          />
          <button
            onClick={handleSearch}
            className="bg-[#173363] hover:bg-blue-900 text-white px-8 py-3 rounded-md whitespace-nowrap"
          >
            Search
          </button>
          <button
            onClick={handleReset}
            className="bg-gray-700 hover:bg-gray-600 text-white px-8 py-3 rounded-md whitespace-nowrap"
          >
            Reset
          </button>
        </div>
      </div>

      {/* User List */}
      <div className="bg-white shadow-md rounded-lg p-4 text-[#030229] py-3 px-6 font-nunito font-bold text-xl leading-none mb-8">
        <h2 className="font-poppins font-medium text-3xl leading-none text-[#173363] mb-12 pt-8">
          User List
        </h2>
        <div className="grid grid-cols-5 mb-6">
          <div>ID</div>
          <div>User Name</div>
          <div>Email</div>
          <div>Phone No</div>
          <div>Actions</div>
        </div>
      </div>

      {/* Table Body */}
      <div className="space-y-6 p-2">
        {state.displayedUsers.map((user, index) => (
          <div
            key={user.id}
            className="bg-white shadow-sm rounded-lg py-5 px-6 grid grid-cols-5 items-center text-sm"
          >
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {user.id}
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {user.name}
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {user.email}
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {user.phone}
            </div>
            <div>
              <button
                onClick={() => handleToggleStatus(user.id, index)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
                  user.active ? "bg-green-500" : "bg-red-500"
                }`}
                role="switch"
                aria-checked={user.active}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    user.active ? "translate-x-6" : "translate-x-1"
                  }`}
                />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <Pagination
        currentPage={state.currentPage}
        totalPages={Math.ceil(totalUsers / itemsPerPage)}
        onPageChange={(page) => setState({ ...state, currentPage: page })}
      />
    </div>
  );
}
